/**
 * @Author: Klaudie <klaudie@foxprofi.cz>
 */

import { apiClient } from '../client'
import type { UserProfile } from '@/types/auth.types'
import type { PaginatedResponse } from '@/types/api.types'

export interface CreateUserRequest {
  email: string
  password: string
  firstName: string
  lastName: string
  avatar?: string | null
  phone?: string | null
  isActive?: boolean
  roleIds: string[]
}

export interface UpdateUserRequest {
  email?: string
  firstName?: string
  lastName?: string
  avatar?: string | null
  phone?: string | null
  isActive?: boolean
  password?: string
  roleIds?: string[]
}

/**
 * Získání seznamu uživatelů (admin+)
 */
export const getUsers = async (params?: {
  page?: number
  perPage?: number
}): Promise<PaginatedResponse<UserProfile>> => {
  const response = await apiClient.get<PaginatedResponse<UserProfile>>('/api/admin/users', {
    params,
  })
  return response.data
}

/**
 * Získání detailu uživatele
 */
export const getUser = async (id: string): Promise<UserProfile> => {
  const response = await apiClient.get<UserProfile>(`/api/admin/users/${id}`)
  return response.data
}

/**
 * Vytvoření nového uživatele
 */
export const createUser = async (data: CreateUserRequest): Promise<UserProfile> => {
  const response = await apiClient.post<UserProfile>('/api/admin/users', data)
  return response.data
}

/**
 * Aktualizace uživatele
 */
export const updateUser = async (id: string, data: UpdateUserRequest): Promise<UserProfile> => {
  const response = await apiClient.patch<UserProfile>(`/api/admin/users/${id}`, data)
  return response.data
}

/**
 * Smazání uživatele
 */
export const deleteUser = async (id: string): Promise<void> => {
  await apiClient.delete(`/api/admin/users/${id}`)
}
